(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  const form = document.getElementById('ContactForm');
  if (!form || form.dataset.inquiryTrackingBound) return;
  form.dataset.inquiryTrackingBound = 'true';
  const key = 'stickericon.inquiry.pending.v1';
  const success = !!form.querySelector('[data-inquiry-success]');
  const clear = () => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const allowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy?.currentVisitorConsent().analytics === 'yes'
      && privacy.analyticsProcessingAllowed() === true;
  };
  form.addEventListener('submit', () => {
    clear();
    if (!form.checkValidity() || !allowed()) return;
    const params = new URLSearchParams(location.search);
    const product = ['custom-labels', 'custom-stickers'].includes(params.get('product'))
      ? params.get('product') : 'general';
    const language = document.documentElement.lang.split('-')[0];
    try {
      sessionStorage.setItem(key, JSON.stringify({
        id: crypto.randomUUID(), at: Date.now(), product,
        language: ['en','de','fr','es'].includes(language) ? language : 'other'
      }));
    } catch (_) {}
  });
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) clear();
  });
  const complete = () => {
    if (!success) { clear(); return; }
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(key)); } catch (_) { clear(); return; }
    clear();
    if (!allowed() || !pending || !/^[a-f0-9-]{36}$/.test(pending.id)
      || Date.now() - pending.at < 0 || Date.now() - pending.at > 900000
      || !['custom-labels','custom-stickers','general'].includes(pending.product)
      || !['en','de','fr','es','other'].includes(pending.language)) return;
    if (typeof window.Shopify?.analytics?.publish !== 'function') return;
    window.Shopify.analytics.publish('stickericon:inquiry_success', {
      version: 1, submission_id: pending.id, product: pending.product,
      language: pending.language, analytics_consent: true
    });
  };
  if (window.Shopify?.customerPrivacy) complete();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], (error) => {
      if (error) { clear(); return; }
      complete();
    });
  } else clear();
})();

  (() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('quote') !== 'custom-size') return;
    const summary = document.querySelector('[data-size-quote-summary]');
    const body = document.getElementById('ContactForm-body');
    if (!summary || !body || body.value.trim()) return;
    const product = params.get('product');
    const width = Number(params.get('width'));
    const height = Number(params.get('height'));
    const unit = params.get('unit');
    const quantity = params.get('quantity');
    const quantities = product === 'custom-stickers' ? [50,100,200,300,500,1000,2000,3000,5000,10000] : [100,200,500,1000,2000,3000,5000,10000,20000];
    const count = Number(String(quantity).replace(/\s*pcs$/, ''));
    if (!['custom-stickers','custom-labels'].includes(product) || !['in','cm'].includes(unit)
      || !Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0
      || !quantities.includes(count)) return;
    const factor = unit === 'cm' ? 2.54 : 1;
    const minimumWidth = (product === 'custom-stickers' ? 1.5 : 1) * factor;
    const maximumWidth = (product === 'custom-stickers' ? 26 : 18) * factor;
    const maximumHeight = (product === 'custom-stickers' ? 26 : 14) * factor;
    const normalize = (value) => Number(value.toFixed(10));
    if (width < normalize(minimumWidth) || height < normalize(factor)
      || width > normalize(maximumWidth) || height > normalize(maximumHeight)) return;
    const productTitle = product === 'custom-stickers' ? summary.dataset.stickers : summary.dataset.labels;
    body.value = `${summary.dataset.heading}\n${summary.dataset.productLabel}: ${productTitle}\n${summary.dataset.sizeLabel}: ${width} × ${height} ${unit}\n${summary.dataset.quantityLabel}: ${count}\n\n${summary.dataset.details}\n`;
    body.dispatchEvent(new Event('input', { bubbles: true }));
    summary.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
